import { useIsLoggedIn } from '@apis/queries/useIsLoggedIn/useIsLoggedIn';
import { isTestEnv } from '@functions/functions';
import { useQueryClient } from '@tanstack/react-query';
import { APP_LINKS } from '@utils/variables';
import { useRouter } from 'next/router';
import { FC, useEffect, useState } from 'react';
import { newsKeys } from '../../apis/queries/news.queriesKeys';
import useNews from '../../apis/queries/useNews';
import NewsModal from '../NewsModal';
import { INews } from '../NewsModal/NewsModal.type';

const NewsMaster: FC = () => {
	const router = useRouter();
	const queryClient = useQueryClient();

	const { isLoggedIn } = useIsLoggedIn();
	const { latestNews } = useNews();

	const [news, setNews] = useState<INews | null>(null);

	const closeModal = () => {
		setNews(null);
		queryClient.setQueryData(newsKeys.all, []);
	};

	useEffect(() => {
		if (
			!isLoggedIn ||
			!latestNews?.data ||
			router.pathname.includes(APP_LINKS.auth.href) ||
			(isTestEnv() && !router.query.featureNewsMasterActivated)
		)
			return;

		/*
			set the latest news in the local state and
		 	clear news query cache to avoid opening the news on refresh
		*/
		setNews(latestNews);
		queryClient.setQueryData(newsKeys.all, []);
	}, [isLoggedIn, latestNews, queryClient, router.pathname, router.query]);

	return news?.data ? <NewsModal isOpen={!!news} onClose={closeModal} {...news.data} /> : null;
};

export { NewsMaster };
